export default __webpack_public_path__ + "b20374014bda8c0ce4d6b9987b0f144b.svg";